<template>
    <div style="z-index: 11">
        <v-menu min-width="250" offset-y v-model="menuOpen" :close-on-content-click="false">
            <template v-slot:activator="{ on, attrs }">
                <v-btn depressed fab v-bind="attrs" v-on="on" class="" :disabled="disabled">
                    <v-badge
                        overlap
                        color="#ab0658"
                        bordered
                        :content="tributeNotificationsStore?.unreadNotifications?.length"
                        :value="tributeNotificationsStore?.hasUnreadNotifications"
                    >
                        <v-avatar v-bind="attrs" v-on="on" size="55" color="#dbe2e8">
                            <v-img v-if="profileUrl" :src="profileUrl" @error="$emit('profile-error')"></v-img>
                            <font-awesome-icon v-else icon="fa-solid fa-user"></font-awesome-icon>
                        </v-avatar>
                    </v-badge>
                </v-btn>
            </template>
            <v-card>
                <v-list dense class="profile-menu">
                    <v-list-item>
                        <v-list-item-title>
                            <h5>
                                {{ profileName }}
                            </h5>
                        </v-list-item-title>
                    </v-list-item>
                    <v-list-item
                        v-if="!state.isContributor"
                        @click="
                            tributeNotificationsStore.toggle();
                            menuOpen = false;
                        "
                    >
                        <font-awesome-icon
                            class="mr-2"
                            icon="fa-solid fa-bell-exclamation"
                            style="color: #9ca3af"
                        ></font-awesome-icon>
                        <span style="color: #374151">Notifications</span>
                        <v-spacer />
                        <v-chip
                            class="mr-1"
                            small
                            dark
                            color="#ab0658"
                            v-if="tributeNotificationsStore.hasUnreadNotifications"
                            >New
                        </v-chip>
                    </v-list-item>
                    <template v-if="state.isMobile">
                        <v-divider class="my-1"></v-divider>
                        <ShareMenu mode="list-item"> </ShareMenu>
                    </template>
                    <template v-if="!state.isContributor">
                        <v-divider class="my-1"></v-divider>

                        <v-list-item @click="$refs.scanningModal.open()" v-if="tributeVideo?.deeplink">
                            <font-awesome-icon
                                style="color: #9ca3af"
                                class="mr-2"
                                icon="fa-solid fa-film-cannister"
                            ></font-awesome-icon>
                            <span style="color: #374151">Scan printed photos</span>
                        </v-list-item>
                        <!-- <v-list-item v-if="tributeVideo?.id" @click="initProfileUpdate">
                            <font-awesome-icon
                                style="color: #9ca3af"
                                class="mr-2"
                                icon="fa-solid fa-rotate"
                            ></font-awesome-icon>
                            <span style="color: #374151">Change Image</span>
                        </v-list-item> -->
                        <!-- <v-list-item v-if="mainPhotoId" @click="$refs.editModal.open()">
                            <font-awesome-icon
                                style="color: #9ca3af"
                                class="mr-2"
                                icon="fa-regular fa-pencil"
                            ></font-awesome-icon>
                            <span style="color: #374151">Edit Image</span>
                        </v-list-item> -->
                        <!-- <v-list-item
                            :disabled="!mainPhotoId"
                            class="danger"
                            @click="openProfileRemoveConfirmationModal"
                            v-if="!state.isContributor && mainPhotoId"
                        >
                            <font-awesome-icon
                                class="mr-2"
                                icon="fa-regular fa-trash-can"
                                style="color: #ef4444"
                            ></font-awesome-icon>
                            <span style="color: #b91c1c">Remove Image</span>
                        </v-list-item> -->
                        <v-list-item
                            v-if="!state.isFamily && !state.isContributor && tributeVideo?.id"
                            class=""
                            @click="openSettingsModal"
                        >
                            <font-awesome-icon
                                class="mr-2"
                                icon="fa-regular fa-cog"
                                style="color: #9ca3af"
                            ></font-awesome-icon>
                            <span style="color: #374151">Settings</span>
                        </v-list-item>

                        <v-list-item @click="performanceSettingsModal = true">
                            <font-awesome-icon
                                class="mr-2"
                                icon="fa-regular fa-rabbit-running"
                                style="color: #9ca3af"
                            ></font-awesome-icon>
                            <span style="color: #374151">Performance</span>
                        </v-list-item>

                        <v-list-item
                            v-if="!state.isFamily && !state.isContributor"
                            @click="openTab(`/tribute-slideshow/${$route.params.slug}`)"
                        >
                            <font-awesome-icon
                                class="mr-2"
                                icon="fa-regular fa-images"
                                style="color: #9ca3af"
                            ></font-awesome-icon>
                            <span style="color: #374151">Service Viewer</span>
                        </v-list-item>
                    </template>
                    <v-divider v-if="!state.isFamily && !state.isContributor" class="my-1"></v-divider>

                    <v-list-item
                        v-if="!state.isFamily && !state.isContributor"
                        @click="$router.push(`/services/${$route.params.slug}`)"
                    >
                        <img :src="require(`@/assets/images/icon_dark.png`)" alt="logo" class="ms-icon" />
                        <span style="color: #374151">Back to MemoryShare</span>
                    </v-list-item>
                </v-list>
            </v-card>
        </v-menu>

        <SlideUpload
            ref="menuProfileUploader"
            @filesAdded="file => handleUpdateProfileImage(file)"
            @progress="val => handleProgress(val)"
            :maxFiles="1"
            :videoAllowed="false"
            :disabled="disableProfileUpdate"
            hidden
        />
        <PhotoEditorModal
            v-if="mainPhotoId && state.token && tributeVideo.eventId"
            ref="editModal"
            :mainPhotoId="mainPhotoId"
            :token="state.token"
            :isMobile="state.isMobile"
            :eventId="tributeVideo.eventId"
        />
        <TributeEditorSettingsModal v-if="state.token" ref="settingsModal" :token="state.token" />
        <ScanningAppModal v-if="state.token && tributeVideo && tributeVideo.deeplink" ref="scanningModal" />

        <Toasty v-if="tributeVideo?.id" :tribute-video="tributeVideo" />
        <v-dialog v-model="profileRemoveConfirmationModal" max-width="400px">
            <v-card>
                <v-card-title>Remove Profile Photo</v-card-title>
                <v-card-text>Are you sure you want to remove the profile image?</v-card-text>
                <v-card-actions class="d-flex justify-space-between">
                    <v-btn depressed @click="profileRemoveConfirmationModal = false">Close</v-btn>
                    <v-btn :disabled="!mainPhotoId" @click="deleteProfilePhoto" color="error" depressed>Confirm</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="performanceSettingsModal" max-width="400px">
            <v-card>
                <v-card-title>Performance Settings</v-card-title>
                <v-card-text>
                    <v-radio-group v-model="performanceRadioGroup">
                        <v-radio color="#ff530d" label="" :value="tributePerformanceModeEnum.FEATURES">
                            <template v-slot:label>
                                <div class="d-flex flex-column">
                                    <span> Best Features </span>
                                    <i class="caption"> Auto Preview Refresh</i>
                                </div>
                            </template>
                        </v-radio>
                        <span class="text-caption"></span>
                        <v-radio color="#ff530d" :value="tributePerformanceModeEnum.BALANCED">
                            <template v-slot:label>
                                <div class="d-flex flex-column">
                                    <span> Balanced </span>
                                    <i class="caption"> Manual Preview Refresh </i>
                                </div>
                            </template>
                        </v-radio>
                        <v-radio color="#ff530d" :value="tributePerformanceModeEnum.PERFORMANCE">
                            <template v-slot:label>
                                <div class="d-flex flex-column">
                                    <span> Best Performance </span>
                                    <i class="caption">No Preview</i>
                                </div>
                            </template>
                        </v-radio>
                    </v-radio-group>
                </v-card-text>

                <v-card-actions>
                    <v-btn depressed @click="performanceSettingsModal = false">close</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
import initApiServices from '@/services/ApiInitializer';
import { mapStores, mapActions } from 'pinia';
import SlideUpload from '@/components/Tribute/SlideUpload.vue';
import ShareMenu from './ShareMenu.vue';
import PhotoEditorModal from '../Modals/PhotoEditorModal.vue';
import TributeEditorSettingsModal from '../Modals/TributeEditorSettingsModal.vue';
import ScanningAppModal from '../Modals/ScanningAppModal.vue';
import Toasty from '../Toasty.vue';
import { useTributeNotifications } from '@/stores/tributeNotifications';
import { useTributeVideoStore } from '@/stores/tributeVideo';
import { getTributePerformanceMode, setTributePerformanceMode } from '../../../utilities/session';

import { tributePerformanceModeEnum } from '@/constants';
import { useGlobalState } from '@/stores/globalState';
export default {
    setup() {
        return {
            tributeVideoStore: useTributeVideoStore(),
        }
    },
    data() {
        return {
            tributePerformanceModeEnum,
            menuOpen: false,
            apiService: null,
            showSettingsModal: false,
            showScanAppModal: false,
            profileRemoveConfirmationModal: false,
            performanceSettingsModal: false,
            performanceRadioGroup: 0,
        };
    },
    inject: ['state'],
    props: {
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    watch: {
        performanceRadioGroup(newVal) {
            setTributePerformanceMode(newVal);

            this.tributeVideoStore.performanceMode = newVal;
        },
        performanceSettingsModal(newVal) {
            if (newVal) {
                this.fetchSelectedPerformanceMode();
            }
        },
    },
    components: { SlideUpload, ShareMenu, PhotoEditorModal, TributeEditorSettingsModal, ScanningAppModal, Toasty },
    computed: {
        profileName() {
            return `${this.tributeVideoStore.firstName} ${this.tributeVideoStore.lastName}`;
        },
        profileUrl() {
            return this.tributeVideoStore.mainPhotoUrl;
        },
        mainPhotoId() {
            return this.tributeVideoStore.mainPhotoId;
        },
        contributorDetailsSet() {
            return this.tributeVideoStore.contributorDetailsSet;
        },
        disableProfileUpdate() {
            return this.state.isContributor || (this.state.isFamily && !this.contributorDetailsSet);
        },
        tributeVideo() {
            return this.tributeVideoStore;
        },
        profileUploadProgress() {
            return this.tributeVideoStore.profileUploadProgress;
        },
        showProfileUploadProgress() {
            return this.tributeVideoStore.showProfileUploadProgress;
        },

        ...mapStores(useTributeNotifications),
    },
    methods: {
        ...mapActions(useGlobalState, ['showSnackbar']),
        // ...mapActions('tributeVideo', [
        //     'updateProfileUploadProgress',
        //     'updateShowProfileUploadProgress',
        //     'updatePendingProfileUpload',
        // ]),
        async fetchSelectedPerformanceMode() {
            const mode = await getTributePerformanceMode();

            if (mode >= 0) {
                this.performanceRadioGroup = mode;
            }
        },
        openTab(url) {
            window.open(url, '_blank');
        },
        moveToSetup() {
            this.$emit('change-step', 'setup');
            this.menuOpen = false;
        },
        handleProgress(val) {
            if (val > this.profileUploadProgress) {
                this.tributeVideoStore.updateProfileUploadProgress(val);
            }
        },
        initProfileUpdate() {
            if (this.disableProfileUpdate) {
                if (this.state.isFamily && !this.contributorDetailsSet) {
                    this.showSnackbar({ message: 'Please set set your details to continue', color: 'error' });
                } else {
                    this.showSnackbar({ message: 'This action is currently unavailable', color: 'error' });
                }
            }

            this.moveToSetup();
            const uploader = this.$refs.menuProfileUploader;

            if (!uploader || typeof uploader.openFileSelection !== 'function') {
                throw new Error('Error initiating upload');
            }

            return uploader.openFileSelection();
        },
        async handleUpdateProfileImage(file) {
            try {
                this.tributeVideoStore.updateShowProfileUploadProgress(true);

                this.tributeVideoStore.updatePendingProfileUpload(file);

                const uploadResp = await this.uploadPhoto(this.tributeVideo.eventId);
                this.tributeVideoStore.updatePendingProfileUpload(null);

                if (uploadResp.data.length === 0) {
                    this.showSnackbar({ message: 'Error updating profile', color: 'error' });
                    return;
                }

                this.tributeVideoStore.updateTributeVideo({
                    mainPhotoUrl: uploadResp.data[0].url,
                    mainPhotoId: uploadResp.data[0].id,
                });

                this.showSnackbar({ message: 'Profile picture updated' });
            } catch {
                console.log(error, 'error');
            } finally {
                this.tributeVideoStore.updateProfileUploadProgress(0);
                this.tributeVideoStore.updateShowProfileUploadProgress(false);
            }
        },
        uploadPhoto(eventId) {
            if (!eventId || eventId <= 0) {
                throw new Error('Invalid event id');
            }

            const uploader = this.$refs.menuProfileUploader;

            if (!uploader || typeof uploader.initUpload !== 'function') {
                throw new Error('Error initiating upload');
            }

            //For Profile Image, replaceMain must be set to true;
            return uploader.initUpload(eventId, true);
        },
        openProfileRemoveConfirmationModal() {
            this.profileRemoveConfirmationModal = true;
        },
        // confirmAction(action, callback) {
        //     let confirmMessage = 'Are you sure?';
        //     let button = {
        //         text: 'Confirm',
        //         color:'red',
        //         callback: callback
        //     }
        //     switch (action) {
        //         case 'removeImage':
        //             confirmMessage = 'Are you sure you want to remove the profile image?';
        //         break;
        //     }
        //     this.showSnackbar({ message: confirmMessage, button });
        // },
        async deleteProfilePhoto() {
            this.profileRemoveConfirmationModal = false;
            const photoId = this.mainPhotoId;
            this.menuOpen = false;

            if (!photoId) {
                this.showSnackbar({ message: 'Error deleting profile photo', color: 'error' });
                return;
            }

            this.tributeVideoStore.updateTributeVideo({
                mainPhotoId: 0,
                mainPhotoUrl: null,
            });

            try {
                await this.apiService.tributePhoto.deletePhoto(photoId);
                this.showSnackbar({ message: 'Profile picture deleted' });
            } catch (error) {
                console.log(error, 'error deleting  profile photo');
            }
        },
        async setAuthToken() {
            const response = await this.$auth.getIdTokenClaims();
            this.token = response.__raw;
        },
        openSettingsModal() {
            if (this.$refs.settingsModal) {
                this.$refs.settingsModal.open();
            } else {
                // If settingsModal isn't available yet we'll attempt again on an interval
                const refWatcher = setInterval(() => {
                    if (this.$refs.settingsModal) {
                        clearInterval(refWatcher);
                        this.$refs.settingsModal.open();
                    }
                }, 250);
            }
        },
    },
    async mounted() {
        if (this.state.token) {
            this.token = this.state.token;
        } else {
            await this.setAuthToken();
        }
        this.apiService = initApiServices(this.token);

        this.$root.$on('tribute:open-settings-modal', () => {
            this.openSettingsModal();
        });
        this.fetchSelectedPerformanceMode();
    },
};
</script>
<style lang="scss" scoped>
.profile-menu {
    // min-width: 500px;
}

.v-list-item {
    &.v-list-item--disabled {
        opacity: 0.6;
    }
}
.ms-icon {
    width: 18px;
    margin-left: -2px;
    margin-right: 6px;
    filter: contrast(0.1);
}
</style>
